export type EventListener<T> = (data: T) => void;

export default class EventBus {
    private static events: { [event: string]: EventListener<any>[] } = {};
    /**
     * 监听事件
     * @param event 
     * @param listener 
     */
    public static on<T>(event: string, listener: EventListener<T>): void {
        
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(listener);
    }

    /**
     * 触发事件
     * @param event 
     * @param data 
     */
    public static emit<T>(event: string, data: T): void {
        
        if (this.events[event]) {
            this.events[event].forEach(listener => {
                listener(data);
            });
        }
    }

    /**
     * 移除监听器
     * @param event 
     * @param listener 
     */
    public static off<T>(event: string, listener: EventListener<T>): void {
        if (this.events[event]) {
            this.events[event] = this.events[event].filter(fn => fn !== listener);
        }
    }
}